import { useCallback, useEffect, useMemo, Suspense } from 'react'
import { useQueryLoader } from 'react-relay'
import {
  HomeQuery,
  HomeQuery$variables,
} from './__generated__/HomeQuery.graphql'
import Home, { homeQuery } from './Home'
import HomeLoading from './HomeLoading'
import { useGlobalState } from '../state/v2/store'
import { MetaAdsFilter } from '../features/creative/__generated__/SubmitCreativeForApprovalConfirmDialogMutation.graphql'
import { HomeListType, useTypeParam } from '../state/url/type'

export const getMetaAdListQueryVariables = (type: string) => {
  const metaAdsFilter: MetaAdsFilter = {}
  if (type === HomeListType.APPROVED.toString()) {
    metaAdsFilter.approved = true
    metaAdsFilter.created = false
  } else if (type === HomeListType.CREATED.toString()) {
    metaAdsFilter.created = true
  } else if (type === HomeListType.DRAFT.toString()) {
    metaAdsFilter.submittedForApproval = false
  } else if (type === HomeListType.UNAPPROVED.toString()) {
    metaAdsFilter.submittedForApproval = true
    metaAdsFilter.approved = false
  }

  return { metaAdsFilter }
}

const HomeRoute = () => {
  return (
    <Suspense fallback={<HomeLoading />}>
      <HomeRouteView />
    </Suspense>
  )
}

export default HomeRoute

export const HomeRouteView = () => {
  const [homeQueryRef, loadHomeQuery] = useQueryLoader<HomeQuery>(homeQuery)
  const brandId = useGlobalState((b) => b.brand?.map((brand) => brand.id).join(","))
  const [type] = useTypeParam()
  const homeQueryVariables = useMemo(
    () =>
      ({
        ...getMetaAdListQueryVariables(type),
        input: { id: brandId },
      }) as HomeQuery$variables,
    [brandId, type]
  )

  const refreshData = useCallback(() => {
    if (homeQueryVariables.input.id) {
      loadHomeQuery(homeQueryVariables, { fetchPolicy: 'network-only' })
    }
  }, [loadHomeQuery, homeQueryVariables])

  useEffect(() => {
    if (type != null) {
      refreshData()
    }
  }, [type, refreshData])

  const body =
    homeQueryRef == null ? (
      <HomeLoading />
    ) : (
      <Home homeQueryRef={homeQueryRef} refreshData={refreshData} />
    )
  return body
}
